<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><span epub:type="pagebreak" id="page_v" title="v">CONTENTS</span></p>
<p class="toc-entry" id="rint"><span><a href="#/xhtml/Introduction#int">Introduction</a></span></p>
<p class="toc-entry" id="rpt1"><span><a href="#/xhtml/Part001#pt1">Part One: Outsider Mentality</a></span></p>
<p class="toc-entryc" id="rch1"><span><span class="hide">          </span><a href="#/xhtml/Chapter001#ch1">1. Beyond Sanity</a></span></p>
<p class="toc-entryc" id="rch2"><span><span class="hide">          </span><span href="#/xhtml/Chapter002#ch2" title="Link target outside of Sample">2. Beyond Feminism</span></span></p>
<p class="toc-entryc" id="rch3"><span><span class="hide">          </span><span href="#/xhtml/Chapter003#ch3" title="Link target outside of Sample">3. Beyond Normal</span></span></p>
<p class="toc-entry" id="rpt2"><span><span href="#/xhtml/Part002#pt2" title="Link target outside of Sample">Part Two: After the Gatekeepers</span></span></p>
<p class="toc-entryc" id="rch4"><span><span class="hide">          </span><span href="#/xhtml/Chapter004#ch4" title="Link target outside of Sample">4. Beyond Hollywood</span></span></p>
<p class="toc-entryc" id="rch5"><span><span class="hide">          </span><span href="#/xhtml/Chapter005#ch5" title="Link target outside of Sample">5. Beyond Top 40</span></span></p>
<p class="toc-entry" id="rpt3"><span><span href="#/xhtml/Part003#pt3" title="Link target outside of Sample">Part Three: The Center Cannot Hold</span></span></p>
<p class="toc-entryc" id="rch6"><span><span class="hide">          </span><span href="#/xhtml/Chapter006#ch6" title="Link target outside of Sample">6. Beyond Meat</span></span></p>
<p class="toc-entryc" id="rch7"><span><span class="hide">          </span><span href="#/xhtml/Chapter007#ch7" title="Link target outside of Sample">7. Beyond Mass Markets</span></span></p>
<p class="toc-entry" id="rbm1"><span><span href="#/xhtml/Postscript#bm1" title="Link target outside of Sample">Postscript</span></span></p>
<p class="toc-entryb" id="rbm2"><span><span href="#/xhtml/Afterword#bm2" title="Link target outside of Sample">Afterword</span></span></p>
<p class="toc-entryb" id="rbm3"><span><span href="#/xhtml/Acknowledgments#bm3" title="Link target outside of Sample">Acknowledgments</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6ce4f1e4